/**
 * Customer-facing product names for Daily Reveal.
 *
 * Daily Reveal is the internal game type; players never see that phrase. Each sport ships
 * as its own branded product, so My Games labels a player's entries with the name printed
 * on the contest they opened rather than "Daily Reveal".
 *
 * The matching artwork lives in `packages/style-config`
 * (`DAILY_REVEAL_MAIN_HEADER_LOGO_BY_SPORT`); keep the two in step when a sport is added.
 * The lobby cannot import that package — it vendors only api-types, ui, frontend-shared and
 * the platform-config types — so the names are duplicated here deliberately.
 */
const DAILY_REVEAL_PRODUCT_NAME_BY_SPORT: Record<string, string> = {
  NFL: 'Gridiron Draw',
  MLB: 'Big League Draw',
  NBA: 'Full Court Draw',
};

/**
 * A sport with no brand of its own falls back to Big League Draw, matching
 * `resolveDailyRevealBrandingStyle`'s permanent fallback — so the lobby heading and the logo
 * the player sees after tapping through never disagree.
 */
export const DAILY_REVEAL_DEFAULT_PRODUCT_NAME = 'Big League Draw';

export function dailyRevealProductName(sport: string | null | undefined): string {
  const code = String(sport ?? '')
    .trim()
    .toUpperCase();
  return DAILY_REVEAL_PRODUCT_NAME_BY_SPORT[code] ?? DAILY_REVEAL_DEFAULT_PRODUCT_NAME;
}
